/**
* This file is intended to be used from both the web and mobile versions
*
*  @author Machi
*/
var Marb = (function(){
	var _initialized = false,
		_properties={};

	var marb = {
		initialize : function(params) {
			if(! _initialized ) {
				//  log (1) < debug (2) < info (3) < warn (4) < error (5)
				//debug.setLevel( params.properties.clientLogLevel || 4 );

				for(var p in params.properties) {
					_properties[p] = params.properties[p];
				}

				jQuery.i18n.properties({
				    name:['messages', 'custom_messages'],
				    path: M.Commons.getProp('webUrl') + 'i18n/',
				    mode:'map',
				    language: params.language,
				    callback: function() {
				    }
				});

				$(document).bind('fileuploadsubmit', function() {
					M.Loader.block();
				});

				$(document).bind('fileuploadalways', function() {
					M.Loader.unblock();
				});

				// Prevent file uploading through image pasting (only worked in Chrome)
				$(document).bind('fileuploadpaste', function(e, data) {
					// Return 'true' if paste content is not a file
					return !(data && data.files && data.files.length > 0);
				});

				if('me' in params) {
					M.me = new M.User(params.me);
				}

				_initialized = true;
			}

			return M;
		},
		/**
		 * Extend Marb namespace by attaching the properties
		 * of the object provided as paramter.
		 * Note: it is a shallow copy
		 */
		extend : function(o, receiver) {
			var receiver = receiver || M;
			for(var p in o) {
				var subO = o[p];
				if (typeof subO != 'object' || !(p in receiver)) {
					receiver[p] = subO;
				}
				else {
					M.extend(subO, receiver[p]);
				}
			}

			return M;
		},
		/**
		* This object represents the currently logged user (if any). Otherwise, null
		*/
		me : null,

		Math: {
			toDecimal: function(value){
				return parseFloat(Math.round(value * 100) / 100).toFixed(2);
			}
		},

		/**
		* This object represents an IFIX user
		*/
		User : function(params) {
			if( Object.prototype.toString.call( params ) !== '[object Object]') {
			    throw "Cannot create a Marb user. Expected params to be an object.";
			} else {
				if(!'id' in params) {
					throw "Cannot create a Marb user without at least providing a marb id";
				} else if (!'type' in params) {
					throw "Cannot create a Marb user without knowing type of user [customer | company]";
				}
			}

			this.marbId = params.marbId;
			this.type = params.type;
			this.email = params.email;
			this.firstName = params.firstName;
			this.lastName = params.lastName;
			this.social = {};

			if('social' in params) {
				var ps = params.social;
				for(var s in ps) {
					this.social[s] = new M.SocialUser(ps[s]);
				}
			}
		},
		SocialUser : function(params) {
			this.socialId = params.socialId;
			this.marbId = params.marbId || 0;
			this.type = params.type || null;
			this.displayName = params.displayName;
			this.imageUrl = params.imageUrl;

			if(!('status' in params)) {
				this.status = {
					connection : 'unknown',
					innerData : null
				};
			}
			else {
				this.status = params.status;
			}

			this.equals = function(o) {
				if(o == null) return false;
				if(!(o instanceof M.SocialUser)) return false;

				return (o.socialId === this.socialId || o.marbId === this.marbId);
			};

			var _self = this;
			var sanitizeName = function() {
				var parts;
				if(_self.displayName && _self.displayName.indexOf('.') != -1) {
					parts = _self.displayName.split('.');
					_self.displayName = M.Commons.Utils.capitalizeFirstLetter(parts[0]) + ' ' + M.Commons.Utils.capitalizeFirstLetter(parts[1]);
				}
			};

			sanitizeName();
		},
		SocialCompany : function(params) {
			this.companyId = params.companyId;
			this.owner = new M.User(params.owner);
			this.customers = [];

			if(params.customers) {
				for(var i=0, c=params.customers, len=c.length; i<len; i++) {
					this.customers.push(new M.SocialUser(c[i]));
				}
			}
		},
		Loader : {
            blockCustomMessage : function(message) {
                var messageHtml = '<div class="loadingBox"><div class="img"></div><h4 class="msg"><i class="fa fa-gear fa-spin" style="margin-right:8px;"/>' + message + '</h4></div>';
                Marb.Loader.blockFunction(messageHtml);
            },
			block : function(e) {
				var messageHtml = '<div class="loadingBox"><div class="img"></div><h4 class="msg"><i class="fa fa-gear fa-spin" style="margin-right:8px;"/>' + $.i18n.prop('p.generic.loading') + '</h4></div>';
				Marb.Loader.blockFunction(messageHtml);
			},
            blockFunction : function(messageHtml) {
                $.blockUI({
                    message: messageHtml,
                    css: {
                        width: '15%',
                        'min-width': '250px',
                        left: '50%',
                        'margin-left': '-125px',
                        height: 'auto',
                        border: 'none'
                    }
                });
            },
			unblock : function() {
				$.unblockUI();
			}
		},
		Commons : {
			getProp : function (p) {
				if( p in _properties ) {
					return _properties[p];
				}
				else {
					debug.warn('Unexistent property request to Marb.Commons.getProp',p);
				}
			},
			Msgs : {
				/**
				 * Loads messages from the specified selector. It is expected the
				 * selector to contain input hidden objects where the key and values
				 * are used to store messages
				 */
				loadFrom : function(selector){
					if( ! selector ){
						selector = '#generic-msgs';
					}
					$(selector).find('input[type=hidden]').each(function(){
						var obj = $(this);
						var key = obj.attr('name');
						var val = obj.attr('value');
						Marb.Commons.Msgs[key] = val;
					});

					return Marb.Commons.Msgs;
				},
				/**
				 * Insert a message (messages must have been previously loaded
				 * thourgh Marb.Msgs.loadFrom) replacing the given params into
				 * the message
				 *
				 * messageCode: String (eg. 'p.generic.publishDate.minutes')
				 * params: Array (eg. [15])
				 */
				insertWithParam : function(messageCode, params) {
					function escapeRegExp(str) {
					  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
					}

					var msg = Marb.Commons.Msgs[messageCode];
					if(msg) {
						for(var i=0, len=params.length, exp; i<len; i++) {
							exp = new RegExp(escapeRegExp('{'+i+'}'),'g');
							msg = msg.replace(exp, params[i]);
						}
					}
					else {
						debug.warn('Marb.Commons.Msgs.insertWithParam - messageCode not found.', {messageCode : messageCode});
					}

					return msg;
				}
			},
			Track : {
				conversion: function(){
					dataLayer.push({
						event: 'conversion-lead'
					});
				},
				event : function(){
					var data = {};
					var lastArg = arguments[arguments.length-1];
					var lastTermCallbackPresent = (typeof lastArg === 'function');
					var termCount = arguments.length;
					if( lastTermCallbackPresent ){
						termCount--;
					}
					switch( arguments.length){
						case 1:
							data = { 'event': 'trackEvent', 'category': arguments[0]};
							break;
						case 2:
							data = { 'event': 'trackEvent', 'category': arguments[0], 'action': arguments[1]};
							break;
						case 3:
							data = { 'event': 'trackEvent', 'category': arguments[0], 'action': arguments[1], 'value': arguments[2] };
							break;
					};
					console.log('track: ' + JSON.stringify(data));
					
					if( lastTermCallbackPresent ){
						var complexData = [];
						complexData.push(data);
						complexData.push({
								'eventCallback': lastArg
							});
						dataLayer.push(complexData);
						//gtag missing fallback
						setTimeout(lastArg, 500);
					}else{
						dataLayer.push(data);
					}
				},
			},
			Utils : {
				/**
				 * Executes code after scrolling that lets you
				 * take actions based on a given element
				 * being in the viewport or not.
				 * Normally this method is used to track when a given
				 * elem is out of the screen so you can toggle another
				 * element on.
				 * the viewport.
				 * params:
				 * - fixed: a selector that identifies the element to be
				 * 		fixed on screen.
				 * - onHide: optional function that gets executed when the fixed
				 * 		element is not visible anymore (out of screen). Receives
				 * 		as parameters (fixed) -- after a scroll
				 * - onShow: optional function that gets executed when the fixed
				 * 		element is visible (after a scroll)
				 */
				trackInViewport : function(params){
					//this executes very often
					var fixedElem = $(params.fixed);
					var onHide = params.onHide || function(fixedElem){
							fixedElem.addClass('tiv-hidden');
						};
					var onShow = params.onShow || function(fixedElem, overlayElem){
						fixedElem.removeClass('tiv-hidden');
						};
					$(window).on('scroll', function(){
						if( Marb.Commons.Utils.isInViewport(fixedElem[0]) ){
							onShow(fixedElem);
						}else{
							onHide(fixedElem);
						}
					});
				},
				/**
				 * Locks an element in the viewport meaning that when it is
				 * partially hidden it is locked at the top of the window.
				 * It may optionally be locked in reference to another
				 * element (params.reference)
				 * Parameters:
				 * params.selector: the object selector to lock in view
				 * params.reference: optional reference selector to be used as lock-reference for params.selector
				 * params.maxScrollV: optional reference to an object that may not be overlapped by selector (i.e. max scroll)
				 */
				lockInViewport : function(params){
					var element = $(params.selector);
					//create a placeholder to check if element is (partially) visible or not
					var placeholder = $('<div id="lala" style="position: absolute; top: 0px;"/>');
					$('body').append(placeholder);
					var refElem = element;
					if( params.reference ){
						refElem = $(params.reference);
					}
					placeholder.css('top', refElem.offset().top);
					placeholder.css('left', refElem.offset().left);
					
					var checkMaxV = params.maxScrollV !== undefined;
					var maxV = 0;
					var maxScrollV = params.maxScrollV;
					var maxScrollVDelta = params.maxScrollVDelta || 0;
					
					var delta = params.topOffsetDelta || 99;
					var initialTop = 0;
					
					//save vars so we can restore them later
					var style = element.attr('style');
					$(window).on('scroll', function(params){
						var inViewport = Marb.Commons.Utils.isInViewport(placeholder[0]) || 
							placeholder.offset().top >= $('body').scrollTop();
						if( !inViewport && !element.hasClass('view-overlay') ){
							element.addClass('view-overlay');
							if( params.extraClass ){
								element.addClass(params.extraClass);
							}
							var oWidth = element.css('width');
							var oHeight = element.css('height');

							element.css('left', element.offset().left);
							var top = element.offset().top - refElem.offset().top;
							initialTop = top;
							element.css('top', top);
							element.css('z-index', 900);
							element.css('position', 'fixed');
							element.css('width', oWidth);
							
							element.css('height', oHeight);
						}else if( ! inViewport && checkMaxV ){
							var targetV = $(maxScrollV);
							maxV = targetV.offset().top + 
							       maxScrollVDelta;
							var curV = element.offset().top + 
									   parseFloat(element.css('height'),10);
							var scrollTop = $('body').scrollTop();
							var hasClass = element.hasClass('view-maxV');
							var elemScrollTop = element.data('liv_scroll');
							if( curV >= maxV && ! hasClass){
								element.addClass('view-maxV');
								var initial = parseFloat(element.offset().top, 10);
								element.css('position', 'absolute');
								element.css('top', initial - delta);
								element.data('liv_scroll', scrollTop );
							}else if( hasClass && elemScrollTop && elemScrollTop > scrollTop ){
								element.removeClass('view-maxV');
								element.css('top', initialTop);
								element.css('position', 'fixed');
								element.data('liv_scroll', null);
							}
						} else if( inViewport && element.hasClass('view-overlay')){
							element.removeClass('view-overlay');
							if( params.extraClass ){
								element.removeClass(params.extraClass);
							}
							element.attr('style', style ? style : null);
						}
					});
				},
				isInViewport : function( elm ) {
					var vpH = $(window).height(), // Viewport Height
						st = $(window).scrollTop(), // Scroll Top
						y = $(elm).offset().top,
						h = $(elm).height();
					return (y > st && y+h < (vpH + st));
				},
				accordion : function(params){
					var accordion = $(params.selector);
					var first = accordion.find('.accordion-item:first');
					first.addClass('accordion-open');
					first.find('.body').show();
					accordion.find('.accordion-item .title').on('click', function(){
						var title = $(this);
						var parent = title.closest('.accordion-item');
						var closeCurrent = parent.hasClass('accordion-open');
						var selected = accordion.find('.accordion-item.accordion-open');
						selected.find('.body').hide(400);
						selected.removeClass('accordion-open');
						if( ! closeCurrent ){
							parent.addClass('accordion-open');
							parent.find('.body').show(400);
						}
					});
				},
				/**
				 * Returns true if we are currently working in a
				 * small (<640px) screen.
				 */
				isSmallScreen : function(){
					return $(window).width() <= 640;
				},
				
				/**
				 * Returns true if we are currently working in a
				 * full (desktop) screen or width > 640px
				 */
				isFullScreen : function(){
					return $(window).width() > 640;
				},
				
				getURLParameter : function (name) {
				    return decodeURI(
				        (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
				    );
				},
				/**
				 * Check if a string is blank
				 */
				isBlank : function( text ) {
				    return !text || !/\S/.test(text);
				},
				/**
				 * Check if valid dd/mm/yyyy date.
				 * does not check for leap  years and what not.
				 */
				isValidDateDdMmYyyy: function(text){
					var parts = text? text.split("/") : "";
					var is = true;
					if( parts && parts.length == 3){
						try{
							var dd = parseInt(parts[0]);
							var mm = parseInt(parts[1]);
							var yy = parseInt(parts[2]);
							is = dd >= 1 && dd <= 31 &&
								 mm >= 1 && mm <= 12 &&
								 yy > 1899;
							if( mm == 4 || mm == 6 || mm == 9 || mm == 11  ){
								is = is && dd <= 30;
							}
							if( mm == 2){
								if( yy % 4 == 0 && yy % 200 != 0){
									is = is && dd <= 29;
								}else{
									is = is && dd <= 28;
								}
							}
						}catch(error){
							is = false;
						}
					}else{
						is = false;
					}
						
					return is;
				},
				/**
				* Capitalize the first letter of the given string
				*/
				capitalizeFirstLetter : function(str)
				{
				    return str.charAt(0).toUpperCase() + str.slice(1);
				},
                formatDateyyyyMMdd : function(date) {
                    var year = date.getFullYear();
                    var month = (1 + date.getMonth()).toString();
                    month = month.length > 1 ? month : '0' + month;
                    var day = date.getDate().toString();
                    day = day.length > 1 ? day : '0' + day;
                    return year + '/' + month + '/' + day;
                },
				/**
				* Scroll to the bottom of the given element
				* 'element' can be a css selector, a dom or jQuery object
				*/
				scrollToBottom : function(element) {
					var $e = $(element);
					$e.scrollTop($e[0].scrollHeight);

					return M.Commons.Utils;
				},
				scrollToTop: function(element){
					var elem = $(element);
					if( elem.length > 0 ){
						$('html, body').animate({
							scrollTop: elem.offset().top
						}, 600);
					}
				},
				
				/** Transforms a NUMBER into a 
				 * an i18n string. Amount is a float number
				 * (most likley) */
				formatCurrency : function(amount){
					var value = new Number(amount);
					var symbol = $.i18n.prop('p.generic.currencySymbol');
					var localeDecSep= $.i18n.prop('p.generic.decimalSeparator');
					var localeIntSep= $.i18n.prop('p.generic.numberSeparator');
					
					var decimalSeparator = Number("1.2").toLocaleString().substr(1,1);
					var hundredSeparator = Number("1000").toLocaleString().substr(1,1);
					if( isNaN(hundredSeparator) ){
						hundredSeparator = hundredSeparator.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
					}else{
						//in some computers there is no hundred separator
						//so we just use an invalid string
						hundredSeparator = "X";
					}
					var browserFormat = amount.toLocaleString();
					var arParts = String(browserFormat).split(decimalSeparator);
					var intPart = arParts[0].replace(new RegExp(hundredSeparator, 'g'), localeIntSep);
					var decPart = (arParts.length > 1 ? arParts[1] : '');
					decPart = (decPart + '00').substr(0,2);

					return symbol + intPart + localeDecSep + decPart;
				},

				/**
				 * Returns a json object specifying how many days, hours, minutes, seconds
				 * elapsed between the startTime and endTime dates
				 * 'endTime' is optional. If not present current date will be used
				 */
				elapsedTime : function(startTime, endTime) {
					endTime = endTime || new Date();

					// time difference in ms
					var timeDiff = endTime - startTime;

					// strip the miliseconds
					timeDiff /= 1000;

					// get seconds
					var seconds = Math.round(timeDiff % 60);

					// remove seconds from the date
					timeDiff /= Math.round(60);

					// get minutes
					var minutes = Math.round(timeDiff % 60);

					// remove minutes from the date
					timeDiff /= Math.round(60);

					// get hours
					var hours = Math.round(timeDiff % 24);

					// remove hours from the date
					timeDiff /= Math.round(24);

					// get days
					var days = Math.round(timeDiff % 30);

					// remove days from the date
					timeDiff /= Math.round(30);

					// the rest of timeDiff is number of months
					var months = Math.floor(timeDiff);

					return {
						months: months,
						days: days,
						hours: hours,
						minutes: minutes,
						seconds: seconds
					};
				},
				/**
				 * Returns a readable-friendly text for time elapsed
				 * between two dates (1 second ago, 3 weeks ago, etc.).
				 * the 'to' parameter is optional and now() is used if omitted
				 */
				elapsedTimeText : function(from, to){
					to = to || new Date();
					var creationTimeElapsed = Marb.Commons.Utils.elapsedTime(new Date(from), to);
					var timeAgo = '', key = '', formatedDate;
					if(creationTimeElapsed.months > 11) {
						moment.lang($.i18n.prop('p.generic.publishDate.old.lang'));
						key = 'p.generic.publishDate.old.text';
						formatedDate = moment(from).format($.i18n.prop('p.generic.publishDate.old.dateFormat'));
						timeAgo = $.i18n.prop(key,formatedDate);
					}
					else if(creationTimeElapsed.months > 0) {
						key = 'p.generic.publishDate.months.';
						key += creationTimeElapsed.months > 1? 'plural' : 'singular';
						timeAgo = $.i18n.prop(key,creationTimeElapsed.months);
					}
					else if(creationTimeElapsed.days > 0) {
						key = 'p.generic.publishDate.days.';
						key += creationTimeElapsed.days > 1? 'plural' : 'singular';
						timeAgo = $.i18n.prop(key,creationTimeElapsed.days);
					}
					else if (creationTimeElapsed.hours > 0) {
						key = 'p.generic.publishDate.hours.';
						key += creationTimeElapsed.hours > 1? 'plural' : 'singular';
						timeAgo = $.i18n.prop(key,creationTimeElapsed.hours);
					}
					else if (creationTimeElapsed.minutes > 0) {
						key = 'p.generic.publishDate.minutes.';
						key += creationTimeElapsed.minutes > 1? 'plural' : 'singular';
						timeAgo = $.i18n.prop(key,creationTimeElapsed.minutes);
					}
					else {
						key = 'p.generic.publishDate.seconds.';
						key += creationTimeElapsed.seconds > 1? 'plural' : 'singular';
						timeAgo = $.i18n.prop(key,creationTimeElapsed.seconds);
					}

					return timeAgo;
				},
				/**
				 * Logs the user in. This method is SYNC and will return a boolean
				 * indicating the operation's success
				 */
				login : function (username, password) {
					var result = false;
					$.ajax({url: "/ajaxLogin", type: "POST", async: false, dataType: 'json',
						data: {j_username: username, j_password: password}, success: function(data){
							result = data.success;
					}});
					return result;
				},
				registerUser : function (newUser) {
					var result = false;
					$.ajax({url: "ajax/customer/registration", 
							type: "POST", 
							async: false, 
							dataType: 'json',
							data: {
								username : newUser.username,
							    firstname : newUser.firstname,
							    lastname : newUser.lastname,
							    phone : newUser.phone,
							    password :newUser.password,
							    passwordConfirm : newUser.passwordConfirm,
							    marketingSource :newUser.marketingSource
						    }, 
						    success: function(data){
						    	result = data.success;
						    },
						    error: function(xhr, status, error) {
						        alert(status);
					        }
					});
					return result;
				},
				
				getParameterByName: function(name) {
				    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
				    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
				        results = regex.exec(location.search);
				    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
				},
				/**
				*	Expecting an object with an array per value, it will
				*	transpose these.
				*
				*	For exmple, if input is '{"a1":["b12","b15"],"a2":["b15"],"a3":[],"a4":["b5","b15"]}'
				*	output will be '{"b12":["a1"],"b15":["a1","a2","a4"],"b5":["a4"]}'
				*/
				transposeArrayInObject : function(mapIn) {
					var mapOut={};
					for(var key in mapIn) {
						for(var i=0, v=mapIn[key], len=v.length; i<len; i++) {
							if(!(v[i] in mapOut)) {
								mapOut[v[i]] = [];
							}
							mapOut[v[i]].push(key);
						}
					}

					return mapOut;
				},
				
				/**
				 * Defines if the numbers given in the credit card
				 * are valid or not (looks for errors, the card
				 * might not actually exist)
				 * source: https://gist.github.com/DiegoSalazar/4075533
				 */
				isValidCreditCard : function(value) {
					if (/[^0-9-\s]+/.test(value)) return false;
				 
					var nCheck = 0, nDigit = 0, bEven = false;
					value = value.replace(/\D/g, "");
				 
					for (var n = value.length - 1; n >= 0; n--) {
						var cDigit = value.charAt(n),
							nDigit = parseInt(cDigit, 10);
				 
						if (bEven) {
							if ((nDigit *= 2) > 9) nDigit -= 9;
						}
				 
						nCheck += nDigit;
						bEven = !bEven;
					}
				 
					return (nCheck % 10) == 0;
				}
			}
		},
		Notification : {
			check : function(onSuccess, onError){
				if( Notification ){
					Notification.requestPermission().then(function(result) {
						if( result !== 'granted'){
							if( onError ){
								onError(result);
							}else{
								alert('Aceptar permisos de Notificaciones');
							}
							
							return;
						}else{
							if(onSuccess){
								onSuccess();
							}
						}
					});
				}
			},
			notify : function(title, body, icon, onClick){
				var params = {
					body: body,
					icon: icon
				};
				var notification = new Notification(title, params);
				if( onClick ){
					notification.addEventListener('click', onClick);
				}
			}
		}
	};

	return marb;
})();

var M = Marb;
